import type { SyncOp } from '@wr/shared';

/** A short line for a saved change, as the person would name it. */
export function describeChange(op: SyncOp): string {
  if (op.entity === 'lead_contact') {
    return op.action === 'link' ? 'Contact added to a lead' : 'Contact removed from a lead';
  }
  if (op.action === 'delete') return `${ENTITY[op.entity]} deleted`;
  const f = op.fields as Record<string, string | undefined>;
  const name =
    op.entity === 'contact'
      ? [f.first_name, f.last_name].filter(Boolean).join(' ') || f.company
      : op.entity === 'lead'
        ? f.company_name
        : op.entity === 'event'
          ? f.series
          : op.entity === 'expense'
            ? f.vendor
            : f.text?.slice(0, 40);
  return name ? `${ENTITY[op.entity]}: ${name}` : `${ENTITY[op.entity]} changed`;
}

const ENTITY = {
  contact: 'Contact',
  lead: 'Lead',
  event: 'Event',
  event_note: 'Event note',
  expense: 'Receipt',
};

/** Why the server refused a change, in a sentence. */
export function rejectionMessage(error: string | null): string {
  switch (error) {
    case 'forbidden':
      return 'Your roles do not allow this change.';
    case 'invalid':
    case 'lead_answers_required':
      return 'Some details are missing or not valid.';
    case 'not_found':
    case 'deleted':
      return 'This record no longer exists on the server.';
    case 'not_an_image':
      return 'The photo is not an image the portal can read. Scan the card again.';
    case 'too_large':
      return 'The photo is over 25 MB. Scan the card again.';
    case 'last_contact':
      return 'A lead keeps at least one contact.';
    case 'sent':
      return 'This receipt was already sent to accounting: it cannot change any more.';
    case 'conflict':
      return 'The record was changed elsewhere in a way that conflicts.';
    default:
      return 'The server refused this change.';
  }
}
